module.exports = __webpack_public_path__ + "img/login.a11983ea.jpg";